module.exports = __webpack_public_path__ + "images/tr_import/upload@2x-69246d1e02a52f3348db46d699b499a2.png";